module.exports = __webpack_public_path__ + "static/media/blueWithdrawal19.7d61ac1c.svg";